import * as React from 'react';
import { Button, Checkbox } from '@cian/ui-kit';
import { ModalConfirm } from '../../ModalConfirm';
import { IPrintOptions } from '../../../types/redux/print';
import * as styles from './ModalPrint.css';

interface IProps {
  options: IPrintOptions;
  text: string;
  onChangeOption(optionName: string, value: boolean): void;
  onPrint(): void;
  onCancel(): void;
}

export function ModalPrint({ options, text, onChangeOption, onCancel, onPrint }: IProps) {
  return (
    <ModalConfirm
      text={text}
      onClose={onCancel}
      isVisible={true}
      footer={
        <Button size="XS" onClick={onPrint}>
          Распечатать
        </Button>
      }
    >
      <div className={styles['row']}>
        <Checkbox
          label="Печатать номера телефонов"
          checked={options.printPhoneNumbers}
          onChange={(e, isChecked) => onChangeOption('printPhoneNumbers', isChecked)}
        />
      </div>
      <div className={styles['row']}>
        <Checkbox
          label="Печатать мои заметки"
          checked={options.printNotes}
          onChange={(e, isChecked) => onChangeOption('printNotes', isChecked)}
        />
      </div>
    </ModalConfirm>
  );
}
